const toggles = document.querySelectorAll(".js-menu-toggle");
const menu = document.getElementById("mobile-menu");

toggles.forEach((toggle) => {
	toggle.addEventListener("click", () => {
		const expanded = menu.classList.contains("translate-x-0");
		const newState = !expanded;
		menu.hidden = !newState;
		document.body.classList.toggle("no-scroll", newState);
		menu.classList.toggle("translate-x-0", newState);
		menu.classList.toggle("translate-x-full", !newState);
		toggles.forEach((t) => t.setAttribute("aria-expanded", String(newState)));
	});
});
